<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2 pb-2">
            <div
              class="row bg-gradient-info shadow-black border-radius-lg pt-4 pb-3 mb-3"> 
              <h6 class="col text-white text-capitalize ps-3">Reports</h6>
            </div>       
         
            <Loading message="Loading your reports" :loading = "loading"/>

            <!-- Token not found -->
            <div class="col-12 d-flex justify-content-center" v-if="(Array.isArray(returnAPI.reports) == false && showMessage == true && loading == false)">
              <div id="not_found_token" class="col-4 ps-3 alert alert-danger fw-bold" v-if="error == true">
                Sorry, token not found.
              </div>

              <div id="not_found" class="col-4 ps-3 alert alert-warning fw-bold" v-else>
                Databases files not found.
              </div>
            </div>

            <div id="report" v-else-if="Array.isArray(returnAPI.reports) && loading == false">             
              <div id = "total" role="alert" class= "col ps-3 w-25 alert alert-danger" v-if = "returnAPI.reports.length == 0 && showMessage == true"> There are no reports. </div>
              <div id = "total" role="alert" class= "col ps-3 w-25 alert alert-success" v-if = "returnAPI.reports.length == 1  && showMessage == true"> There's {{ returnAPI.reports.length }} report found. </div>
              <div id = "total" role="alert" class= "col ps-3 w-25 alert alert-success" v-if = "returnAPI.reports.length > 1 && showMessage == true">There're {{ returnAPI.reports.length }} reports found. </div>

              <ReportTable :returnAPI="{ reports: paginatedReports }"/>

              <!-- Pagination -->
              <nav v-if="totalReports > 0" class="pagination-bar" aria-label="Reports pagination">
                <span class="pagination-info">
                  Exibindo <strong>{{ pageStart }}&ndash;{{ pageEnd }}</strong>
                  de <strong>{{ totalReports }}</strong>
                  relatório{{ totalReports === 1 ? "" : "s" }}
                </span>

                <ul v-if="totalPages > 1" class="pagination-list">
                  <li>
                    <button
                      type="button"
                      class="page-btn page-btn--nav"
                      :disabled="currentPage === 1"
                      aria-label="Previous page"
                      @click="goToPage(currentPage - 1)"
                    >
                      <i class="material-icons-round notranslate">chevron_left</i>
                    </button>
                  </li>

                  <li v-for="(item, index) in pageItems" :key="`page-${index}`">
                    <span v-if="item === '...'" class="page-ellipsis">&hellip;</span>
                    <button
                      v-else
                      type="button"
                      class="page-btn"
                      :class="{ 'page-btn--active': item === currentPage }"
                      :aria-current="item === currentPage ? 'page' : null"
                      @click="goToPage(item)"
                    >
                      {{ item }}
                    </button>
                  </li>

                  <li>
                    <button
                      type="button"
                      class="page-btn page-btn--nav"
                      :disabled="currentPage === totalPages"
                      aria-label="Next page"
                      @click="goToPage(currentPage + 1)"
                    >
                      <i class="material-icons-round notranslate">chevron_right</i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <LastUpdateInfo />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from "@/views/components/ReportTable.vue";
import Loading from "@/views/components/Loading.vue";
import {http} from "../http/index";
import LastUpdateInfo from "./components/LastUpdateInfo.vue";

export default {
  name: "Reports",
  
  components : {
    Loading,
    ReportTable,
    LastUpdateInfo,
  },

  data() {        
    return {
      token:  localStorage.getItem("token"),
      returnAPI: [],
      loading: true,
      showMessage : true,
      error: false,
      currentPage: 1,
      pageSize: 10
    };
  },

  computed: {
    // All reports returned by the API (pagination is done here on the front).
    allReports(){
      return Array.isArray(this.returnAPI.reports) ? this.returnAPI.reports : []
    },

    totalReports(){
      return this.allReports.length
    },

    totalPages(){
      return Math.max(1, Math.ceil(this.totalReports / this.pageSize))
    },

    paginatedReports(){
      const start = (this.currentPage - 1) * this.pageSize
      return this.allReports.slice(start, start + this.pageSize)
    },

    pageStart(){
      return this.totalReports === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1
    },

    pageEnd(){
      return Math.min(this.currentPage * this.pageSize, this.totalReports)
    },

    // First page, last page, the current page and its neighbours; the gaps
    // in between collapse into an ellipsis.
    pageItems(){
      const total = this.totalPages
      const current = this.currentPage

      if (total <= 7) {
        return Array.from({ length: total }, (_, index) => index + 1)
      }

      const pages = new Set([1, total, current, current - 1, current + 1])

      if (current <= 3) {
        pages.add(2).add(3)
      }

      if (current >= total - 2) {
        pages.add(total - 1).add(total - 2)
      }

      const sorted = [...pages].filter((page) => page >= 1 && page <= total).sort((a, b) => a - b)
      const items = []

      sorted.forEach((page, index) => {
        if (index > 0 && page - sorted[index - 1] > 1) {
          items.push("...")
        }

        items.push(page)
      })

      return items
    }
  },

  mounted(){
    this.searchReports()
  },

  methods: {
    goToPage(page){
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return
      }

      this.currentPage = page
    },

    async searchReports(){
      var payload = {
        token: this.token,
        hide_expired_urls: true
      }

      await http.post("/api/v1/dashboard/reports-by-user/", payload)
      .then((response) => {
        this.returnAPI = response.data
        this.currentPage = 1
        this.showMessage = false        
      })
      .catch(() => {        
        this.returnAPI = false
        this.loading = false
        this.error = true
      })
      .finally(() => {
        if (!Array.isArray(this.returnAPI.reports)) {
          this.showMessage = true
        }
        
        this.loading = false
      })
    }
  }
};
</script>

<style scoped>

#total{
  font-size: 16px;
  color: white;
  text-align: center;
}

#loading{
  padding-bottom: 15px;
  text-align: center;
  vertical-align: middle;
}

#not_found{
  color: white;
  text-align: center;
}

#report{
  padding-top: 5px;
  font-size: 16px;
  color: #424242;
}

.pagination-bar{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem 20px 0;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
}

.pagination-info{
  font-size: 0.875rem;
  color: #7b809a;
}

.pagination-info strong{
  color: #344767;
  font-weight: 600;
}

.pagination-list{
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.page-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.25rem;
  height: 2.25rem;
  padding: 0 0.5rem;
  border: 0;
  border-radius: 0.5rem;
  background-color: #ffffff;
  color: #344767;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.15s ease-in-out;
}

.page-btn:hover:not(:disabled):not(.page-btn--active){
  background-color: #e9ecef;
  transform: translateY(-1px);
}

.page-btn--active{
  background-image: linear-gradient(195deg, #49a3f1 0%, #1a73e8 100%);
  color: #ffffff;
  box-shadow: 0 3px 6px rgba(26, 115, 232, 0.35);
  cursor: default;
}

.page-btn--nav i{
  font-size: 18px;
}

.page-btn:disabled{
  color: #bdbdbd;
  box-shadow: none;
  cursor: not-allowed;
}

.page-ellipsis{
  display: inline-block;
  min-width: 1.5rem;
  text-align: center;
  color: #7b809a;
}

</style>
